module.exports = __webpack_public_path__ + "static/media/img_snake_flex_top_right.09ff4f1e.svg";